module.exports = __webpack_public_path__ + "static/media/plus-icon-white.29a944e6.svg";